export class DocumentFilterAttribute {
    typeId: string;
    typeCode: string;
    attributeId: string;
    name: string;
    operator: string;
    value: any;
    displayValue: any;
    min: any;
    max: any;
  }
  export enum QueryOperators {
    Empty = '',
    Eq = '=',
    Lt = '<',
    Gt = '>',
    Lte = '<=',
    Gte = '>=',
    In = '~',
    Range = '[..]',
  }
  export enum AttributeTypes {
    String = 'string',
    Date = 'date',
    Time = 'time',
    DateTime = 'dateTime',
    Number = 'number',
    Reference = 'reference'
  }
  export enum SearchMethods {
    must = 'must'
  }
  export enum SearchConditions {
    bool = 'bool'
  }
  export enum AttributeValues {
    asDate = 'attributes.asDate',
    asDateTime = 'attributes.asDateTime',
    asString = 'attributes.asString',
    asShortString = 'attributes.asShortString',
    asNumber = 'attributes.asNumber',
    asReference = 'attributes.asReference'
  }  
